import React, { useEffect, useContext } from "react";
import { ClientContext } from "graphql-hooks";
import { useNavigate } from "react-router-dom";

const admin_string = process.env.REACT_APP_ADMIN_URL || "/t31u4YYky50K";

/*##########################################################################
## Function    : Logout
## Description : logout user
## Author      : RR
## Date        : 2022/03/12
##########################################################################*/
export default function AdminSignOut() {
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  useEffect(
    () => {
	    localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("role");
        localStorage.removeItem("email");        
        localStorage.removeItem("userName");
        client.removeHeader("Authorization");
      navigate(`${admin_string}/signin/`);
    },
    [localStorage]
  );

  /////////////////////////////////////////////////////////////////////
  return (
    <>
    <title>R3PLAY - Admin Sign Out</title>

    <h2>
      You are logged out. You will be redirected to login page.
    </h2>
    </>
  );
}
